import { useCallback, useEffect } from 'react';

import { Theme, useTheme } from '@src/theming';

/**
 * disable transition in document
 * and return a function to enable them again
 */
const disableAnimation = (): (() => void) => {
  const css = document.createElement('style');
  css.appendChild(
    document.createTextNode(
      `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
    )
  );
  document.head.appendChild(css);

  return (): void => {
    // Force restyle
    window.getComputedStyle(document.body);

    // Wait for next tick before removing
    setTimeout(() => {
      document.head.removeChild(css);
    }, 1);
  };
};

const useInit = (): void => {
  const { theme } = useTheme();

  const applyTheme = useCallback((theme: Theme.LIGHT | Theme.DARK) => {
    // disable all transition animations, to avoid differently timed color transitions
    const enable = disableAnimation();
    const d = document.documentElement;
    d.setAttribute('data-theme', theme);
    // enable transitions again
    enable();
  }, []);

  useEffect(() => {
    applyTheme(theme);
  }, [theme, applyTheme]);
};

export default useInit;
